import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

const DonutChart = ({
    data,
    size = 100,
    centerRadius = 60,
    centerColor = 'rgba(255, 255, 255, 0.1)',
    backgroundColor = 'transparent',
    sx = {},
    ...props
}) => {
    const theme = useTheme();
    const { t } = useTranslation();

    // 기본 데이터 설정 (theme이 정의된 후)
    const defaultData = [
        {
            label: t('didim'),
            value: 0,
            color: theme.palette.figma.steps,
            radius: 45,
            strokeWidth: 10,
        },
        {
            label: t('calories'),
            value: 0,
            color: theme.palette.figma.calorieRed,
            radius: 35,
            strokeWidth: 10,
        },
        {
            label: t('time'),
            value: 0,
            color: theme.palette.figma.time,
            radius: 25,
            strokeWidth: 10,
        },
    ];

    const chartData = data || defaultData;

    // 모든 원형 차트의 중심을 동일하게 설정
    const centerX = size / 2;
    const centerY = size / 2;

    return (
        <Box
            sx={{
                width: size,
                height: size,
                backgroundColor,
                borderRadius: '10px',
                flexShrink: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',
                pointerEvents: 'none', // 터치 이벤트가 부모로 전파되도록
                ...sx,
            }}
            {...props}
        >
            <svg
                width={size}
                height={size}
                viewBox={`0 0 ${size} ${size}`}
                style={{ transform: 'rotate(-90deg)' }}
            >
                {/* Render each donut chart */}
                {chartData.map((item, index) => (
                    <g key={index}>
                        {/* Background circle */}
                        <circle
                            cx={centerX}
                            cy={centerY}
                            r={item.radius}
                            fill="none"
                            stroke={theme.palette.figma.white[(index + 1) * 10]}
                            strokeWidth={item.strokeWidth}
                        />

                        {/* Progress circle */}
                        <circle
                            cx={centerX}
                            cy={centerY}
                            r={item.radius}
                            fill="none"
                            stroke={item.color}
                            strokeWidth={item.strokeWidth}
                            strokeLinecap="round"
                            strokeDasharray={`${2 * Math.PI * item.radius}`}
                            strokeDashoffset={`${2 * Math.PI * item.radius * (1 - item.value / 100)}`}
                            style={{
                                transition:
                                    'stroke-dashoffset 0.5s ease-in-out',
                            }}
                        />
                    </g>
                ))}
            </svg>
        </Box>
    );
};

export default DonutChart;
